import { render, staticRenderFns } from "./InternalOrderDetail.vue?vue&type=template&id=76809cb0&scoped=true"
import script from "./InternalOrderDetail.vue?vue&type=script&lang=js"
export * from "./InternalOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./InternalOrderDetail.vue?vue&type=style&index=0&id=76809cb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76809cb0",
  null
  
)

export default component.exports